import { veeFormFieldHOC } from '@/kasten-components/components/KaVeeFormField';

import { default as KaTextarea } from './KaTextarea.vue';

export { type KaTextareaProps } from './KaTextarea.vue';

export const KaTextareaVee = veeFormFieldHOC(KaTextarea);

export { KaTextarea };
